import type React from 'react';
import { useCostsAndFeesContext } from './context/CostsAndFeesProvider';
import { processApiTextContent } from 'app/shared/utils/totalMonthlyPriceUtils';
import CostsBreakdown from './components/CostsBreakdown';
import CostsFilters from './components/CostsFilters';
import CostsSkeleton from './components/CostsSkeleton';
import {
  ContentColumn,
  ContentRow,
  CostAndFeesBreakdownBoxWrapper,
  CostAndFeesModalContainer,
  DisclaimerTextResponsive,
  TitleWrapper,
} from './CostsAndFeesContent.styles';

interface CostAndFeesContentProps {
  isWebView?: boolean;
}

export const CostAndFeesContent: React.FC<CostAndFeesContentProps> = ({ isWebView = false }) => {
  const { calculatedCostsAndFees } = useCostsAndFeesContext();

  if (!calculatedCostsAndFees) return <CostsSkeleton />;

  const shouldRenderSidebar = () => {
    if (!calculatedCostsAndFees?.selectors) {
      return false;
    }
    const hasMultipleBedTypes = (calculatedCostsAndFees.selectors.beds?.length ?? 0) > 1;
    const hasMultipleUnits = (calculatedCostsAndFees.selectors.units?.length ?? 0) > 1;
    return hasMultipleBedTypes || hasMultipleUnits;
  };

  return (
    <CostAndFeesModalContainer>
      {!isWebView && <TitleWrapper size="lg">Costs & fees breakdown</TitleWrapper>}
      <ContentRow data-testid="costs-fees-content-container">
        {shouldRenderSidebar() && (
          <div>
            <CostsFilters />
            <DisclaimerTextResponsive variant="desktop">
              {(() => {
                const processed = processApiTextContent(calculatedCostsAndFees.disclaimer);

                if (processed.isHtml) {
                  return <span dangerouslySetInnerHTML={{ __html: processed.content }} />;
                } else {
                  return <span style={{ whiteSpace: 'pre-wrap' }}>{processed.content}</span>;
                }
              })()}
            </DisclaimerTextResponsive>
          </div>
        )}
        <ContentColumn data-testid="costs-fees-breakdown-details">
          <CostAndFeesBreakdownBoxWrapper>
            <CostsBreakdown />
          </CostAndFeesBreakdownBoxWrapper>
        </ContentColumn>
      </ContentRow>
      <DisclaimerTextResponsive variant="mobile">
        {(() => {
          const processed = processApiTextContent(calculatedCostsAndFees.disclaimer);

          if (processed.isHtml) {
            return <span dangerouslySetInnerHTML={{ __html: processed.content }} />;
          } else {
            return <span style={{ whiteSpace: 'pre-wrap' }}>{processed.content}</span>;
          }
        })()}
      </DisclaimerTextResponsive>
    </CostAndFeesModalContainer>
  );
};
